// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__LgH3Z","divider--vertical":"divider_divider--vertical__fA2lK"};